import { I18n } from '@calendly/i18n';
import { BodyText, TitleText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { HolidaySettings } from './holiday_settings';
import { FlexContainer } from './styles';
const holidayContainerIsTabletUpCss = "h1mb5xkz";
const holidayContainerCss = "hr0y9sa";
const HolidayContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(holidayContainerCss, {
    [holidayContainerIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
const holidayContentCss = "h1e8jzd9";
const HolidayContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(holidayContentCss, props.className)} />;
});
export const HolidaysSection = () => <HolidayContainer>
    <HolidayContent>
      <FlexContainer>
        <TitleText level={3} size="medium">{I18n.t('publisher.availability_page.advanced_settings.holidays.title')}</TitleText>
        <BodyText color="muted" size="medium">
          {I18n.t('publisher.availability_page.advanced_settings.holidays.subheader')}
        </BodyText>
      </FlexContainer>
      <HolidaySettings />
    </HolidayContent>
  </HolidayContainer>;

require("./holidays_section.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./holidays_section.js");